module.exports = __webpack_public_path__ + "static/media/Non-operative_Education_Packet.5f849c70.pdf";